export default "__VITE_ASSET__C0c5nEg6__"